/* eslint-disable no-use-before-define */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { FixedSizeList } from 'react-window';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
function renderRow(props) {
  const { data, index, style } = props;

  return React.cloneElement(data[index], {
    style: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'block',
      ...style,
    },
  });
}

const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
  const { children, ...other } = props;
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const itemCount = Array.isArray(children) ? children.length : 0;
  const itemSize = smUp ? 36 : 48;

  const outerElementType = React.useMemo(() => {
    return React.forwardRef((props2, ref2) => <div ref={ref2} {...props2} {...other} />);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div ref={ref}>
      <FixedSizeList
        style={{ padding: 0, height: Math.min(8, itemCount) * itemSize, maxHeight: 'auto' }}
        itemData={children}
        height={250}
        width="100%"
        outerElementType={outerElementType}
        innerElementType="ul"
        itemSize={itemSize}
        overscanCount={5}
        itemCount={itemCount}
      >
        {renderRow}
      </FixedSizeList>
    </div>
  );
});
const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.title
  });
export default function ComboBox(props) {
  const cities = props.cities;
  const onTagsChange = (event, values) => {
    props.onChange(values, props.name)
  }
  return (
    <Autocomplete
      id="virtualize"
      ListboxComponent={ListboxComponent}
      disableListWrap
      options={cities}
      getOptionLabel={option => option.title}
      filterOptions={filterOptions}
      disabled={props.disabled}
      onInputChange={onTagsChange}
      inputValue={String(props.value)}
      noOptionsText={props.noOptionsText}
      renderInput={params => (
        <TextField 
        {...params}
        error={props.error} 
        disabled={props.disabled}
        label={props.label} 
        variant={props.variant} 
        className={props.className}
        style={{marginTop: 10}} 
        />
      )}
    />
  );
}


